/* Design 8 header (4 Nov 2026).
   1. No Show parts button, so picking a model (or a sub model) loads the parts. scripts.js already goes
      straight to a collection when the pick maps to one; otherwise this presses the hidden Show parts
      button for the customer, which ds-header.js turns into the model search.
   (The third dropdown's "Sub model" wording for trucks is set in ds-vehicle-switch.js.) */
(function () {
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!e.isTrusted || !s || !s.matches || !s.matches('#DsVband .select-sort-2, #DsVband .select-sort-3')) return;
    if (/^Select /.test(s.value)) return;
    setTimeout(function () {
      var b = document.querySelector('#DsVband .search-by-vehicle-btn');
      if (b) b.click();
    }, 250);
  });

})();
